import * as React from "react";
import CarouselSlide from "../share/CarouselSlide";
import Slide from "../../models/slide";
import Image from "../../components/share/Image";
import { loadImage } from "../../util/image";

export interface Props {
  images: Array<any>;
}

export default function TopSlide({ images }: Props) {
  return (
    <div className="block-nopadding">
      <div className="">
        <div className="row">
      {images &&
        images.length > 0 && (
          <CarouselSlide id="bannerCarousel">
            {images.map((image, index) => {
              return <a key={image.id} href={image.metadata.linkto == true ? image.metadata.href : '#'}><Image
                key={index}
                className="d-block w-100"
                src={image.link_file}
                alt={image.metadata.alt}
                classPlaceHolder={'lazy-image-slide'}
              /></a>
            })}
          </CarouselSlide>
        )}
        </div>
      </div>
    </div>
  );
}

TopSlide["defaultProps"] = {
  images: []
};
